import { cn } from '@endure/ui';

import type { SubMenu } from '../../types';
import { SubMenuItem, type SubMenuItemProps } from './SubMenuItem';

export interface SubMenuContentProps extends Omit<SubMenu, 'items'> {
  items: SubMenuItemProps[];
  chromeVariant?: 'dark' | 'light';
}

export const SubMenuContent: React.FC<SubMenuContentProps> = ({
  variant = 'primary',
  chromeVariant = 'dark',
  items,
}) => (
  <div
    className={cn(
      'rounded-lg',
      variant === 'primary' ? 'min-w-83' : cn('py-3 xl:min-w-137', 'bg-elevated'),
    )}
  >
    <div
      className={cn(
        variant === 'secondary' ? 'sm:grid sm:grid-cols-2 sm:gap-x-3 sm:max-w-137' : 'space-y-3',
      )}
    >
      {items.map((subItem) => (
        <SubMenuItem
          {...subItem}
          variant={variant}
          chromeVariant={chromeVariant}
          key={subItem.label}
        />
      ))}
    </div>
  </div>
);
